module.exports = __webpack_public_path__ + "static/espalogo-84f2e83aad765dbf924361111c6e51ca.png";